import React from "react";
import * as SelectPrimitive from "@radix-ui/react-select";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  CheckIcon,
} from "lucide-react";

export function Select(props) {
  return <SelectPrimitive.Root {...props} />;
}

export function SelectTrigger({ className = "", children, ...props }) {
  return (
    <SelectPrimitive.Trigger
      className={`custom-select-trigger ${className}`}
      {...props}
    >
      {children}
      <SelectPrimitive.Icon asChild>
        <ChevronDownIcon className="custom-select-chevron" />
      </SelectPrimitive.Icon>
    </SelectPrimitive.Trigger>
  );
}

export function SelectContent({ className = "", children, ...props }) {
  return (
    <SelectPrimitive.Portal>
      <SelectPrimitive.Content
        className={`custom-select-content ${className}`}
        {...props}
      >
        <SelectScrollUpButton />
        <SelectPrimitive.Viewport className="custom-select-viewport">
          {children}
        </SelectPrimitive.Viewport>
        <SelectScrollDownButton />
      </SelectPrimitive.Content>
    </SelectPrimitive.Portal>
  );
}

export function SelectScrollUpButton(props) {
  return (
    <SelectPrimitive.ScrollUpButton className="custom-select-scroll-button" {...props}>
      <ChevronUpIcon className="custom-select-icon" />
    </SelectPrimitive.ScrollUpButton>
  );
}

export function SelectScrollDownButton(props) {
  return (
    <SelectPrimitive.ScrollDownButton className="custom-select-scroll-button" {...props}>
      <ChevronDownIcon className="custom-select-icon" />
    </SelectPrimitive.ScrollDownButton>
  );
}

export function SelectItem({ children, className = "", ...props }) {
  return (
    <SelectPrimitive.Item
      className={`custom-select-item ${className}`}
      {...props}
    >
      <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
      <SelectPrimitive.ItemIndicator className="custom-select-item-indicator">
        <CheckIcon className="custom-select-check-icon" />
      </SelectPrimitive.ItemIndicator>
    </SelectPrimitive.Item>
  );
}

export function SelectValue(props) {
  return <SelectPrimitive.Value {...props} style={{backgroundColor:'lightgrey'}} />;
}

export function SelectLabel(props) {
  return <SelectPrimitive.Label className="custom-select-label" {...props} />;
}

export function SelectGroup(props) {
  return <SelectPrimitive.Group {...props} />;
}

export function SelectSeparator(props) {
  return <SelectPrimitive.Separator className="custom-select-separator" {...props} />;
}
